import { Colors, FindLoad, formatAMPMNeW, Images, PermissionList, RolePermission } from '../../../../../utils';
import { ApptDetailRow, DateRow, EditWithIcon, LinkRow, LocalDateRow, MinLoader, SimpleTooltip, TextRow } from '../../../../../components';
import moment from 'moment/moment';
import React from 'react';
import { ApptNoteActions } from './apptNoteActions';

export const clientNoteEnums = {
    CLIENT_NOTES: 'CLIENT_NOTES',
    SESSION_NOTES: 'SESSION_NOTES',
    // MISSING_NOTES: 'UNFILLED_SESSION_NOTES',
};

export const clientNoteTypes = [
    { name: 'Client Notes', id: clientNoteEnums.CLIENT_NOTES },
    { name: 'Session Notes', id: clientNoteEnums.SESSION_NOTES },
    // { name: 'Missing Notes', id: clientNoteEnums.MISSING_NOTES },
];

export const clientNoteHead = [
    { name: 'subject', title: 'Form Title', custom: false, noSearch: true, width: '250px' },
    { name: 'description', title: 'Form Description', custom: false, noSearch: true },
    {
        name: 'date',
        title: 'Created Date',
        icon: 'date',
        width: '150px',
        disabled: true,
        custom: false,
        noSearch: true,
    },
    { name: 'upDate', title: 'Updated', width: '200px', disabled: true, custom: false, noSearch: true },
    { name: 'user', rowName: 'firstName', title: 'Creator Name', width: '200px', custom: false, noSearch: true },
    { name: 'action', title: 'Actions', custom: false, disabled: true, noSearch: true, width: '100px' },
];

export const clientNoteBody = (userInfo) => {
    return [
        {
            rowText: (item) => (
                <div className="flex-align-center" style={{ gap: 8 }}>
                    <div className="client-note-box">
                        <img
                            src={item?.type === clientNoteEnums?.CLIENT_NOTES ? Images.sessionOfficeNote : Images.clientOfficeNote}
                            alt=""
                        />
                    </div>
                    <TextRow name={item?.template?.title} />
                    {/*<TextRow name={item?.title} />*/}
                </div>
            ),
        },
        {
            rowText: (item) => (
                <div className="appt-note-description">
                    <TextRow name={item?.template?.description ? item?.template?.description : '-'} />

                    {/*{item?.description ?*/}
                    {/*    <SimpleTooltip*/}
                    {/*        title={<p dangerouslySetInnerHTML={{ __html: item?.description?.toString('html') }} />}*/}
                    {/*        arrow*/}
                    {/*        placement="top"*/}
                    {/*    >*/}
                    {/*        <p dangerouslySetInnerHTML={{ __html: item?.description?.toString('html') }} />*/}
                    {/*    </SimpleTooltip>*/}
                    {/*    : '-'*/}
                    {/*}*/}
                </div>
            ),
        },
        { rowText: (item) => <DateRow date={item?.created} /> },
        {
            rowText: (item) =>
                item?.updaterFullName && item?.updated ? (
                    <div>
                        {/*<p>{item?.updated ? moment.utc(item?.updated).format('MM/DD/YY, hh:mma') : '-'}</p>*/}
                        <p>{item?.updated ? <LocalDateRow date={item?.updated} /> : '-'}</p>
                        <TextRow name={`by ${item?.updaterFullName}`} textWidth={8} />
                    </div>
                ) : (
                    '-'
                ),
        },
        {
            rowText: (item) => (
                <LinkRow
                    name={item?.creatorFullName ? item?.creatorFullName : '--'}
                    href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.creatorId}` : ''}
                    checkPermission={item?.creatorFullName ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                    textWidth={8}
                />
            ),
            notClickable: true,
        },

        {
            button: (fn, item) => {
                const disable = userInfo?.id === item?.creatorId ? false : !RolePermission([PermissionList.CLIENT_NOTE_MANAGE?.code]);

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <EditWithIcon
                            styles={{ opacity: disable ? 0.5 : 1 }}
                            disabled={disable}
                            icon={Images.edit}
                            id={'edit-appt-note'}
                            handleClick={() => fn('editClientNote')}
                        />
                        <EditWithIcon
                            styles={{ opacity: disable ? 0.5 : 1 }}
                            disabled={disable}
                            icon={Images.redTrash}
                            id={'remove-appt-note'}
                            handleClick={() => fn('deleteNote')}
                        />
                    </div>
                );
            },
            notClickable: true,
        },
    ];
};

export const CLIENT_NOTE_ACTION_TYPE = 'GET_CLIENT_NOTES';

export const clientNoteNotYet = {
    title: 'No Notes Yet',
    subTitle: 'Keep important details here by adding a note.',
    image: Images.noNote,
};

export const clientSessionNoteHead = [
    { name: 'subject', title: 'Title', custom: false, noSearch: true, width: '200px' },
    { name: 'body', title: 'Description', custom: false, noSearch: true },
    { name: 'noteCreator', title: 'Note Creator', custom: false, noSearch: true, width: '150px' },
    { name: 'noteDateTime', title: 'Note Date', custom: false, noSearch: true, width: '130px' },
    // { name: 'subject', title: 'Subject', custom: false, noSearch: true, width: '200px' },
    // { name: 'body', title: 'Body', custom: false, noSearch: true },
    // { name: 'action', title: 'Actions', custom: false, disabled: true, noSearch: true, width: '320px' },
];

export const clientSessionNoteBody = (userInfo, loadRequestRemind, selectedId, apptId) => {
    return [
        {
            // rowText: (item) => <TextRow name={item?.title ? item?.title : '-'} textWidth={8} />,
            rowText: (item) => <TextRow name={item?.template?.title} />,
        },
        {
            rowText: (item) => (
                <div className="appt-note-description">
                    <TextRow name={item?.template?.description ? item?.template?.description : '-'} />

                    {/*{item?.description ?*/}
                    {/*    <SimpleTooltip*/}
                    {/*        title={<p dangerouslySetInnerHTML={{ __html: item?.description?.toString('html') }} />}*/}
                    {/*        arrow*/}
                    {/*        placement="top"*/}
                    {/*    >*/}
                    {/*        <p dangerouslySetInnerHTML={{ __html: item?.description?.toString('html') }} />*/}
                    {/*    </SimpleTooltip>*/}
                    {/*    : '-'*/}
                    {/*}*/}
                </div>
            ),
        },

        {
            rowText: (item) =>
                item?.creatorFullName ? (
                    <LinkRow
                        name={item?.creatorFullName}
                        href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.creatorId}` : ''}
                        checkPermission={item?.creatorId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                        textWidth={8}
                    />
                ) : (
                    '-'
                ),
        },
        {
            rowText: (item) =>
                item?.createdDate ? (
                    <div>
                        <p>{moment.utc(item?.createdDate).format('MM/DD/YYYY')}</p>
                    </div>
                ) : (
                    '-'
                ),
        },

        // {
        //     button: (fn, item) => {
        //         return (
        //             <ApptNoteActions
        //                 afterSuccess={() => {}}
        //                 apptId={apptId}
        //                 editSessionNote={() => fn('editSessionNote')}
        //                 deleteNote={() => fn('deleteNote')}
        //                 selectedId={selectedId}
        //                 item={item}
        //             />
        //         );
        //     },
        //     notClickable: true,
        // },
    ];
};

export const CLIENT_SESSION_NOTE_ACTION_TYPE = 'GET_CLIENT_NOTES';

export const clientSessionNoNoteHead = [
    { name: 'notes', title: 'Notes', custom: false, noSearch: true },
    RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && {
        name: 'action',
        title: 'Actions',
        custom: false,
        disabled: true,
        noSearch: true,
        width: '320px',
    },
];

export const clientSessionNoNoteBody = (appt, loadRequestNote, loadRequestRemind, userInfo, requestingApptId) => {
    return [
        {
            rowText: () => <p>No note has been added for this appointment yet....</p>,
        },
        RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && {
            button: (fn, item) => {
                return (
                    <div className="flex-align-center full-width" style={{ gap: 12 }}>
                        {/*{RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && (*/}
                        {/*    <EditWithIcon icon={Images.addHours} id={'add-appt-note'} handleClick={() => fn('addApptNote')} />*/}
                        {/*)}*/}
                        {appt?.requested ? (
                            <div className="flex-align-center" style={{ gap: 12 }}>
                                {/*{item?.creatorId === userInfo?.id ? (*/}
                                {/*    <SimpleTooltip*/}
                                {/*        title={*/}
                                {/*            <div>*/}
                                {/*                <p>{`Requested on ${moment.utc(item?.requested).format('MM/DD/YY')}`}</p>*/}
                                {/*            </div>*/}
                                {/*        }*/}
                                {/*        arrow*/}
                                {/*        placement="top"*/}
                                {/*    >*/}
                                {/*        <div className="pending-update-box">Pending Update</div>*/}
                                {/*    </SimpleTooltip>*/}
                                {/*) : (*/}
                                    <>
                                        <div className="requested-on">
                                            <img src={Images.greenMark} alt="mark" />
                                            <p>{`Requested on ${moment.utc(item?.requested).format('MM/DD/YY')}`}</p>
                                        </div>

                                        {RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && (
                                            <button style={{ width: 60 }} className="request-note" onClick={() => fn('remindAddNote')}>
                                                {loadRequestRemind?.length ? (
                                                    <MinLoader margin={'0'} color={'#0C66E4'} position="relative" />
                                                ) : (
                                                    'Remind'
                                                )}
                                            </button>
                                        )}
                                    </>
                                {/*// )*/}
                            </div>
                        ) : (
                            RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && (
                                <button style={{ width: 100 }} className="request-note" onClick={() => fn('requestNote')}>
                                    {loadRequestNote?.length && requestingApptId === appt?.apptId ? (
                                        <MinLoader margin={'0'} color={'#0C66E4'} position="relative" />
                                    ) : (
                                        'Request Note'
                                    )}
                                </button>
                            )
                        )}
                    </div>
                );
            },
            notClickable: true,
        },
    ];
};

export const updateNoteEnums = {
    ADD_NOTE: 'ADD_NOTE',
    UPDATE_NOTE: 'UPDATE_NOTE',
    RESOLVE_UPDATE: 'RESOLVE_UPDATE',
};

export const remindEnums = {
    ADD_NOTE: 'ADD_NOTE',
    UPDATE_NOTE: 'UPDATE_NOTE',
};

export const checkNoteEditor = (note, userInfo) => {
    return userInfo?.id === note?.creatorId || RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]);
};
